<template>
  <v-row align="center" no-gutters>
    <v-col cols="12">
      <v-list-item class="ml-n4">
        <v-list-item-avatar>
          <v-img :src="avatar_img"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ nome[0] }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="nome[1] != ''">
            {{ nome[1] }}
          </v-list-item-subtitle>
          <v-list-item-subtitle> {{ prezzo_prodotto}} € </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action-text>
          <span style="font-size: 20px">{{ prodotto.qta }}</span>
          <br>
          {{ tot_conteggiato.toFixed(2) }} €
        </v-list-item-action-text>
        <v-list-item-action v-if="prodotto.lotti.length">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-tag</v-icon>
            </template>
            <span v-for="lotto in prodotto.lotti" :key="lotto">{{ lotto }}</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-col>
  </v-row>
</template>
  
  <script>
import conteggio_prodotto_carrello_mixin from "../../mixin/conteggio_prodotto_carrello_mixin";
export default {
  components: {},
  mixins: [conteggio_prodotto_carrello_mixin],
};
</script>